import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { RoutingRuleAction } from './routingRule.action';
import { routingRuleInitialState } from './routingRule.constant';

export const routingRuleReducer = reducerWithInitialState(routingRuleInitialState)
  .case(RoutingRuleAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(RoutingRuleAction.loadList.done, (state, payload) => {
    return {
      ...state,
      list: payload.result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(RoutingRuleAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(RoutingRuleAction.destroy, () => ({
    ...routingRuleInitialState,
  }));
